import {log} from "@dp-instant/utils";
import {di} from "@dp-instant/core";
import {math} from "@game/coregame/helpers";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {TutorialFingerView} from "@game/coregame/view/TutorialFingerView";
import {gsap} from "gsap/gsap-core";
import {Entity, ReactionSystem} from "tick-knock";
import {Building} from "../entities/Building";

export class TutorialSystem extends ReactionSystem {
    private _tutorialFingerEntityId = NaN;

    constructor() {
        super(e => e.has(Building.ACTIVE_TAG));
    }

    update() {
        // this.engine.removeSystem(this);
    }

    onAddedToEngine() {
        super.onAddedToEngine();
        const view = di.get(TutorialFingerView);
        const tutorialEntity = new Entity().add(view);
        this.engine.addEntity(tutorialEntity);
        this._tutorialFingerEntityId = tutorialEntity.id;

        const from = (this.entities as Building[]).find(
            (e: Building) => e.owner === PlayerType.First
        )!;

        if (!from) {
            log.warn("Tutorial failed, from is " + from);
            return this.engine.removeSystem(this);
        }
        const fromPosition = from.data.statePos;
        const [nearest] = (this.entities as Building[])
            .filter(e => e.owner !== PlayerType.First)
            .sort(
                (a, b) =>
                    math.dist(fromPosition, a.data.statePos) -
                    math.dist(fromPosition, b.data.statePos)
            );
        if (!nearest) {
            log.warn("Tutorial failed, nearest is " + nearest);
            return this.engine.removeSystem(this);
        }
        const [fx, fy] = fromPosition;
        const [tx, ty] = nearest.data.statePos;
        const max_s = 1.2;
        const min_s = 0.7;
        gsap.timeline({repeat: -1})
            .add(gsap.fromTo(view, {alpha: 0}, {alpha: 1}), "appear")
            .add(gsap.fromTo(view.scale, {x: max_s, y: max_s}, {x: min_s, y: min_s}), "appear")
            .fromTo(view, {x: fx, y: fy}, {x: tx, y: ty})
            .add(gsap.fromTo(view, {alpha: 1}, {alpha: 0}), "disappear")
            .add(gsap.fromTo(view.scale, {x: min_s, y: min_s}, {x: max_s, y: max_s}), "disappear");
    }

    onRemovedFromEngine() {
        const fingerEntity = this.engine.getEntityById(this._tutorialFingerEntityId);
        if (fingerEntity) {
            this.engine.removeEntity(fingerEntity);
        }
        super.onRemovedFromEngine();
    }
}
